export const config = {
  modelName: 'homePage',
} as const;
